"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilitySearchDto = instanceOfFacilitySearchDto;
exports.FacilitySearchDtoFromJSON = FacilitySearchDtoFromJSON;
exports.FacilitySearchDtoFromJSONTyped = FacilitySearchDtoFromJSONTyped;
exports.FacilitySearchDtoToJSON = FacilitySearchDtoToJSON;
exports.FacilitySearchDtoToJSONTyped = FacilitySearchDtoToJSONTyped;
/**
 * Check if a given object implements the FacilitySearchDto interface.
 */
function instanceOfFacilitySearchDto(value) {
    return true;
}
function FacilitySearchDtoFromJSON(json) {
    return FacilitySearchDtoFromJSONTyped(json, false);
}
function FacilitySearchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'radiusInMiles': json['radiusInMiles'] == null ? undefined : json['radiusInMiles'],
        'verifiedOnly': json['verifiedOnly'] == null ? undefined : json['verifiedOnly'],
    };
}
function FacilitySearchDtoToJSON(json) {
    return FacilitySearchDtoToJSONTyped(json, false);
}
function FacilitySearchDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'profileId': value['profileId'],
        'lat': value['lat'],
        'lng': value['lng'],
        'radiusInMiles': value['radiusInMiles'],
        'verifiedOnly': value['verifiedOnly'],
    };
}
//# sourceMappingURL=FacilitySearchDto.js.map